// extracted by mini-css-extract-plugin
export default {"wrap":"preloader_wrap__zRRWk","loaderWrap":"preloader_loaderWrap__aJpLo"};